// Helpery do przetwarzania HTML i zawartości konwersacji

import { TFunction } from 'i18next';

/**
 * Tłumaczy tagi <i18n> w HTML na przetłumaczone stringi
 * @param htmlContent - zawartość HTML z tagami <i18n>
 * @param t - funkcja tłumaczenia z i18next
 * @returns HTML z przetłumaczonymi tagami
 */
export const translateI18nTags = (htmlContent: string, t: TFunction): string => {
  if (!htmlContent) return htmlContent;

  const pattern = /<i18n>(.*?)<\/i18n>/g;
  return htmlContent.replace(pattern, (match, textToTranslate) => {
    return t(textToTranslate);
  });
};

/**
 * Wydobywa ostatnie turn-id z HTML (używane do pollingu)
 * @param htmlContent - zawartość HTML z komentarzami turn-id
 * @returns ostatnie turn-id lub null
 *
 * UWAGA: turn-id w komentarzach jest ZNORMALIZOWANY przez `normalizeTurnId`
 * w `api/wiseAiEndpoints/index.ts` — oryginalny backend turn_id typu
 * `turn_20260603100303_e9a3` jest zamieniony na `----20260603100303-e9a3`
 * (znaki spoza `[a-f0-9-]` na `-`). Stad pattern `[a-f0-9-]+` jest poprawny
 * dla znormalizowanej postaci.
 */
export const extractLastTurnId = (htmlContent: string): string | null => {
  if (!htmlContent) return null;

  const pattern = /<!--\s*turn-id:([a-f0-9-]+)\s*-->/gi;
  const matches = Array.from(htmlContent.matchAll(pattern));

  if (matches.length > 0) {
    const lastMatch = matches[matches.length - 1];
    return lastMatch[1];
  }

  return null;
};

/**
 * Zastępuje placeholder URL-e rzeczywistymi wartościami
 * @param content - zawartość HTML
 * @param frontendUrl - rzeczywisty URL frontendu
 * @param backendUrl - rzeczywisty URL backendu
 * @returns HTML z zamienionymi URL-ami
 */
export const replaceUrlPlaceholders = (
  content: string,
  frontendUrl: string,
  backendUrl: string
): string => {
  return content
    .replace(/\{\{FRONTEND_URL\}\}/g, frontendUrl)
    .replace(/\{\{BACKEND_URL\}\}/g, backendUrl);
};

